module.exports = "@media (max-width: 481px) {\n  .ssl-connection {\n    margin-top: 20px; } }\n\n.btn-success[disabled] {\n  background-color: #8e8e98;\n  border: none; }\n  .btn-success[disabled]:hover {\n    background-color: #1db198; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.scss
// module id = ./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.scss
// module chunks = 0